import React from "reactn";
import { withRouter } from "react-router-dom";
import "./ProgramSearchInput.css";
import { SearchIcon } from "../../assets";
import Geosuggest from "react-geosuggest";
import axios from "axios";
import { toast } from "react-toastify";

class SearchBoxData {
  static apiCallTime = null;
  static resultDataPromise = null;
  static aiRecommendedListingsCache = null;
  static aiRecommendedListingsCacheTime = null;

  static async getAllNames() {
    if (Date.now() - SearchBoxData.apiCallTime < 3600000)
      //has it been less than 1hr since last api call?
      return SearchBoxData.resultDataPromise;

    SearchBoxData.apiCallTime = Date.now();
    SearchBoxData.resultDataPromise = axios
      .get(`${process.env.REACT_APP_API}/search`)
      .then(result => {
        //console.log(`result[]:`, result);
        if (!result?.data?.success)
          throw new Error(
            `Unable to get search box auto-complete data. Error=[${
              result?.data?.message || result?.statusText
            }]`
          );
        return result?.data?.data || [];
      })
      .catch(ex => {
        console.error(
          `ProgramSearchInput.jsx: exception during GET /search :`,
          ex
        );
        toast.error(`Search box might not work!`, { autoClose: 10000 });
        return [];
      });
    return SearchBoxData.resultDataPromise;
  }

  static async getAIRecommendedListings(token) {
    if (
      SearchBoxData.aiRecommendedListingsCache &&
      Date.now() - SearchBoxData.aiRecommendedListingsCacheTime < 1800000
    ) {
      return SearchBoxData.aiRecommendedListingsCache;
    }

    try {
      const url = `${process.env.REACT_APP_API}/search/ai-recommended-listings?limit=6`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (
        response?.data?.success &&
        response?.data?.data?.recommendedListings
      ) {
        SearchBoxData.aiRecommendedListingsCache =
          response.data.data.recommendedListings;
        SearchBoxData.aiRecommendedListingsCacheTime = Date.now();
        console.log(
          "AI Recommended Listings:",
          SearchBoxData.aiRecommendedListingsCache
        );
        return SearchBoxData.aiRecommendedListingsCache;
      } else {
        console.log(
          "AI recommended listings not available or unsuccessful response:",
          response
        );
      }
      return [];
    } catch (error) {
      console.error("=== Error in getAIRecommendedListings ===");
      return [];
    }
  }
}

export class ProgramSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      q: props.value || "",
      locationBias: this.getLatLng(),
      searchByAddress: true,
      organizationSearch: "",
      focused: false,
      schools: [],
      aiRecommendedListings: [],
      placesAPILoaded: false
    };
    this._geoSuggest = null;
    this.setAddress = this.setAddress.bind(this);
  }

  //  getPinColor = school => {
  //    return school.programCoverPhoto
  //      ? "red"
  //      : school.clickable
  //      ? "red"
  //      : school.isLive
  //      ? "orange"
  //      : "grey";
  //  };

  //  getUrl = school => {
  //    return school.slug
  //      ? school.clickable
  //        ? `/programs/${school.slug}`
  //        : school.isLive
  //        ? `/kids/${school.slug}`
  //        : school.progress !== 0 &&
  //          school.progress !== 1 &&
  //          school.progress !== 2 &&
  //          school.progress !== 4 &&
  //          school.progress !== 5 &&
  //          `/schools/${school.slug}`
  //      : `#/`;
  //  };

  async componentDidMount() {
    if (!window._shadowRootErrorHandlersAdded) {
      window.addEventListener("unhandledrejection", function (event) {
        if (
          event.reason &&
          event.reason.message &&
          event.reason.message.includes("shadowRoot")
        ) {
          console.warn(
            "Suppressing shadowRoot error from Google Maps integration"
          );
          event.preventDefault();
          return;
        }
      });

      window.addEventListener("error", function (event) {
        if (event.message && event.message.includes("shadowRoot")) {
          console.warn(
            "Suppressing shadowRoot error from Google Maps integration"
          );
          event.preventDefault();
          return;
        }
      });

      window._shadowRootErrorHandlersAdded = true;
    }

    SearchBoxData.getAllNames()
      .then(result => {
        this.setState({ schools: result });
      })
      .catch(ex => {
        console.log("getAllNames error:", ex);
      });

    const token = localStorage.getItem("ds_token");

    if (token) {
      try {
        const recommendedListings =
          await SearchBoxData.getAIRecommendedListings(token);

        console.log("AI LIST:", recommendedListings);
        console.log(
          "this.state.organizationSearch:",
          this.state.organizationSearch
        );
        console.log("this.state.focused:", this.state.focused);

        if (recommendedListings && recommendedListings.length > 0) {
          this.setState({ aiRecommendedListings: recommendedListings });
        } else {
        }
      } catch (ex) {
        console.error("Error:", ex);
      }
    } else {
    }
  }

  componentDidUpdate() {
    /**
     * There was an incident report that involved a white screen of death because the
     * GeoSuggest library was trying to access window.google.maps.places.AutocompleteService().
     * This means that the window.google.maps.places object is undefined so this is a check to
     * ensure that it is loaded.
     */
    try {
      if (window?.google?.maps?.places && !this.state.placesAPILoaded) {
        console.log("LOADED!");
        this.setState({ placesAPILoaded: true });
      } else if (
        document.readyState === "complete" &&
        !this.state.placesAPILoaded &&
        !this.global.warnedOnce
      ) {
        toast.error(
          "Search by location is currently not working. Only search by organization name is available right now.",
          {
            autoClose: 3000,
            position: "top-center"
          }
        );
        this.setGlobal({ warnedOnce: true });
      }
    } catch (error) {
      if (error.message && error.message.includes("shadowRoot")) {
        console.warn("Google Maps Shadow DOM not ready yet, retrying...");
        return;
      }
      console.warn("Error initializing Google Places API:", error);
      if (!this.global.warnedOnce) {
        toast.error(
          "Search by location is currently not working. Only search by organization name is available right now.",
          {
            autoClose: 3000,
            position: "top-center"
          }
        );
        this.setGlobal({ warnedOnce: true });
      }
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    if (!this.state.searchByAddress) {
      this.handleOrganizationEnter(e);
    }
  };

  setAddress = e => {
    console.log("E", e);
    if (e?.location?.lat === -1 && e?.location?.lng === -1) {
      this.setState({ searchByAddress: false });
      return;
    }

    if (e && e.label === "" && e.isFixture) return;

    if (e && e.gmaps) {
      try {
        this.setState({
          q: e.gmaps.formatted_address.split(",")[0],
          lat: e.location.lat,
          lng: e.location.lng
        });
        if (!this.props.noicon)
          if (this.props.location.pathname !== "/register") {
            this.props.history.push(
              `/search/${e.location.lat},${e.location.lng}`
            );
            this.props.shrinknav();
          }

        if (this.props.gLoc)
          this.props.gLoc(e.gmaps.formatted_address, e.location);
      } catch (ex) {
        console.error(ex);
      }
    } else {
      this.setState({ q: e });
      if (this.props.gLoc) if (!this.props.blueborder) this.props.gLoc(e);
    }
  };

  getLatLng() {
    try {
      const locationBias = this.props.locationBias;
      if (locationBias && locationBias.lat && locationBias.long) {
        return new window.google.maps.LatLng(
          locationBias.lat,
          locationBias.long
        );
      }
      //hard-coded values below should eventually be moved elsewhere.

      return new window.google.maps.LatLng(43.671, -79.373);
    } catch (ex) {
      console.log(ex);
      return { lat: 43.671, lng: -79.373 };
    }
  }

  handleOrganizationEnter = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    console.log("handle org enter");
    const { organizationSearch } = this.state;
    if (!organizationSearch.trim()) return;

    const matches = this.getOrganizationOptions();
    const matchingOrganizationPath = this.getOrganizationPath(matches[0]);
    if (matchingOrganizationPath) {
      this.props.history.push(matchingOrganizationPath);
      this.setState({
        organizationSearch: "",
        focused: false
      });
      return;
    }
    // this.props.history.push(
    //   `/search?q=${encodeURIComponent(organizationSearch)}`
    // );
    this.props.history.push(
      `/search?q=${encodeURIComponent(organizationSearch.trim())}`
    );
    this.setState({ focused: false });
  };

  getOrganizationPath(organization) {
    const link = organization && organization.link;
    if (!link) return null;
    return link.startsWith("/") ? link : `/${link}`;
  }

  getOrganizationOptions() {
    if (!this.state.schools) return [];
    const result = this.state.schools.filter(
      org =>
        org.name
          .toLowerCase()
          .substr(0, this.state.organizationSearch.length) ===
        this.state.organizationSearch.toLowerCase()
    );
    return result.slice(0, 6);
    // const result = this.state.organizations.filter(
    //   org =>
    //     (org.program_name || org.programName)
    //       .toLowerCase()
    //       .substr(0, this.state.organizationSearch.length) ===
    //     this.state.organizationSearch.toLowerCase()
    // );
    // const temp = [...result];
    // return temp.reverse();
  }

  render() {
    const hasAIRecommendedListings =
      this.state.aiRecommendedListings.length > 0;
    console.log("hasAIRecommendedListings:", hasAIRecommendedListings);

    return (
      <div
        className={
          this.props.noicon
            ? this.props.blueborder
              ? `n-search-blue`
              : `n-search-reg`
            : "n-search-container"
        }
      >
        <div className={`n-search-header`} style={this.props.style || {}}>
          <form
            className="n-search-main w-100"
            style={{ position: "relative" }}
            onSubmit={this.handleSubmit}
          >
            {this.state.searchByAddress && this.state.placesAPILoaded ? (
              <Geosuggest
                onSuggestSelect={this.setAddress}
                onChange={this.setAddress}
                initialValue={this.state.q}
                placeholder="Search by address or postal code"
                ref={el => (this._geoSuggest = el)}
                location={this.state.locationBias}
                country={"ca" /*restrict searches to Canada only!*/}
                radius={30}
                id={this.props.name ? this.props.name : "geo"}
                autoComplete={"off"}
                fixtures={[
                  {
                    label: "Search by organization",
                    location: { lat: -1, lng: -1 }
                  }
                ]}
                onKeyDown={event => {
                  if (event.key === "Enter" && this.state.q === "") {
                    this.setAddress({
                      gmaps: {
                        formatted_address: ""
                      },
                      location: { lat: 43.671, lng: -79.373 }
                    });
                  }
                }}
                // location={new google.maps.LatLng(53.558572, 9.9278215)}
                // radius="20"
              />
            ) : (
              <div
                style={{
                  position: "relative"
                }}
              >
                <input
                  type="text"
                  onChange={e =>
                    this.setState({ organizationSearch: e.target.value })
                  }
                  placeholder="Search by organization name"
                  onFocus={() => this.setState({ focused: true })}
                  // onBlur={() =>
                  //   setTimeout(() => this.setState({ focused: false }), 100)
                  // }
                  value={this.state.organizationSearch}
                  onKeyDown={event => {
                    if (
                      event.key === "Enter" &&
                      this.state.organizationSearch !== ""
                    ) {
                      this.handleOrganizationEnter(event);
                    }
                  }}
                />
                {this.state.organizationSearch === "" ? (
                  this.state.focused ? (
                    <div className="organization-search">
                      <div
                        className="organization-search-item"
                        onClick={() => this.setState({ searchByAddress: true })}
                      >
                        Search by location
                      </div>

                      {/* AI Recommended Listings Section */}
                      {hasAIRecommendedListings && (
                        <>
                          <div className="organization-search-divider">
                            <span
                              style={{
                                fontSize: "11px",
                                fontWeight: "bold",
                                color: "#2938be",
                                padding: "8px 12px",
                                display: "block",
                                background: "#f0f0ff",
                                borderRadius: "4px",
                                margin: "4px 0"
                              }}
                            >
                              Based on your interests we recommend:
                            </span>
                          </div>
                          {this.state.aiRecommendedListings.map(org => (
                            <div
                              key={org.id}
                              className="organization-search-item"
                              onClick={() => {
                                console.log("clicked");
                                console.log(org.link);
                                const organizationPath = this.getOrganizationPath(
                                  org
                                );
                                if (organizationPath) {
                                  this.props.history.push(organizationPath);
                                }
                                this.setState({
                                  organizationSearch: "",
                                  focused: false
                                });
                              }}
                            >
                              {org.name}
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  ) : null
                ) : this.getOrganizationOptions().length > 0 ? (
                  <div className="organization-search">
                    {this.getOrganizationOptions().map(org => (
                      <div
                        key={org.id}
                        className="organization-search-item"
                        onClick={() => {
                          // this.props.history.push(`/${org.path}/${org.slug}`);
                          // this.props.history.push(this.getUrl(org));
                          const organizationPath = this.getOrganizationPath(org);
                          if (organizationPath) {
                            this.props.history.push(organizationPath);
                          }
                          this.setState({ organizationSearch: "" });
                        }}
                      >
                        {/* {org.program_name || org.programName} */}
                        {org.name}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            )}
            {!this.props.noicon && (
              <button
                type="submit"
                className="n-search-icon-btn"
                disabled={true}
                onClick={this.handleSubmit}
              >
                <img src={SearchIcon} alt="Search" />
              </button>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(ProgramSearchInput);
